import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {useApplication} from "../../ApplicationProvider";
import {useNavigatorFeature} from "../../useFeature";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import LayoutContentToolbar from "../../components/layout/LayoutContentToolbar";
import Table from "../../components/table/Table";
import ListAuthorizationsFeature from "./ListAuthorizationsFeature";
import {renderAuthorizationStateIcon} from "../../components/state/AuthorizationStateRenderer";

function ListAuthorizationsScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new ListAuthorizationsFeature(application, navigator), navigator);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const listAllAuthorizations = () => {
        return (
            <div>
                <LayoutContentToolbar title="Autorizaciones">
                </LayoutContentToolbar>

                <Table
                    columns={feature.columnsContent()}
                    rows={feature.presentedAuthorizations()}
                    navigateToRowObjectScreen={(params) => {
                        const url = feature.authorizationScreenUrl(params.row);
                        window.open(url, '_blank')}}
                    columnsRenderer={{
                        state: renderAuthorizationStateIcon
                    }}
                />
            </div>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => listAllAuthorizations()}/>
    )
}

export default observer(ListAuthorizationsScreen)
